import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './System.module.css';

function System() {
    const [systemData, setSystemData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Default System videos - these will ALWAYS be shown
    const defaultSystemVideos = [
        { videoId: "PpkcXIPMFME", name: "Describing about our system", timestamp: 1 },
        { videoId: "n5DqR_mAP_8", name: "Describing about our system", timestamp: 4704 },
    ];

    // Set default videos directly
    useEffect(() => {
        setSystemData(defaultSystemVideos);
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div className={styles.container}>
                <p className={styles.paragraph}>
                    Affiliate Ritual is introducing India's first-ever Super Affiliate Passive business model. Where anyone can join and start earning from their home and it's totally free! Why are we calling it Super Affiliate or Passive business model? Want to know? Take a look at the videos.
                </p>
                <div style={{ textAlign: 'center', padding: '2rem', color: 'white' }}>
                    Loading videos...
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <p className={styles.paragraph}>
                Affiliate Ritual is introducing India's first-ever Super Affiliate Passive business model. Where anyone can join and start earning from their home and it's totally free! Why are we calling it Super Affiliate or Passive business model? Want to know? Take a look at the videos.
            </p>

            <div className={styles.items}>
                {systemData.map((item, i) => (
                    <motion.div
                        key={i}
                        className={styles.itemWrapper}
                        whileInView={{ opacity: 1, scale: 1 }}
                        initial={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.5 }}
                    >
                        <LazyYouTube videoId={item.videoId} title={item.name} timestamp={item.timestamp} />
                    </motion.div>
                ))}
            </div>
        </div>
    );
}

export default System;

// Lazy Loading YouTube Iframes for Performance Optimization & Timestamp Support
const LazyYouTube = ({ videoId, title, timestamp }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <div className={styles.videoContainer} onClick={() => setIsPlaying(true)}>
            {!isPlaying ? (
                <div className={styles.thumbnailWrapper}>
                    <img
                        className={styles.thumbnail}
                        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                        alt={title}
                        loading="lazy"
                    />
                    <div className={styles.playButton}>▶</div>
                </div>
            ) : (
                <iframe
                    className={styles.video}
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&modestbranding=1&rel=0&start=${timestamp}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={title}
                ></iframe>
            )}
        </div>
    );
};
